module.exports = __webpack_public_path__ + "img/2012300126354659905.18a885d7.png";